import { render, staticRenderFns } from "./AppDiseaseTreeSelector.vue?vue&type=template&id=708cf59a"
import script from "./AppDiseaseTreeSelector.vue?vue&type=script&lang=ts"
export * from "./AppDiseaseTreeSelector.vue?vue&type=script&lang=ts"
import style0 from "./AppDiseaseTreeSelector.vue?vue&type=style&index=0&id=708cf59a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports